import { memo } from 'react';
import { StaticRichTextRenderer } from '@/shared/features/rich-text';
import { cn } from '@/utils/tailwind.util';

/**
 * QuizQuestionText - 리치 텍스트 지원이 있는 질문 텍스트 표시
 * LaTeX 수식이 포함된 HTML 콘텐츠를 표시하기 위해 StaticRichTextRenderer 사용
 * 읽기 전용 버전 (편집 기능 제거됨)
 * @component
 */

interface QuizQuestionTextProps {
  text: string; // TextEditor(Tiptap)의 HTML 문자열
  className?: string;
}
export const QuizQuestionText = memo<QuizQuestionTextProps>(({
  text,
  className
}) => {
  return <StaticRichTextRenderer as="div" text={text} className={cn('text-heading-md-bold', className)} />;
});
QuizQuestionText.displayName = 'QuizQuestionText';